// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"ae8c5518","740":"d53e3fbb"}[chunkId] + ".chunk.css";
};